import type { JSX, HTMLAttributes, ReactNode, FunctionComponent } from "react";
import { cn } from "@repo/lib";
import type { SVGIconProps } from "@repo/icons";

interface BadgeV2RootProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const BadgeV2Root = ({ children, ...props }: BadgeV2RootProps): JSX.Element => {
  return (
    <div
      {...props}
      className={cn(
        "w-fit px-2 text-nowrap flex flex-row rounded-full bg-secondary-50 font-medium text-secondary-500 text-xs justify-center items-center gap-1",
        props.className,
      )}
    >
      {children}
    </div>
  );
};

interface BadgeV2IconProps {
  Icon: FunctionComponent<SVGIconProps>;
  size?: SVGIconProps["size"];
  className?: string;
}

export const BadgeV2Icon = ({
  Icon,
  className,
  size = 12,
}: BadgeV2IconProps): JSX.Element => {
  return <Icon size={size} className={cn("fill-secondary-500", className)} />;
};
